export default {
  "debug": false,
  "eventCategory": "Web Vitals",
  "id": "G-8FYMXRNZGJ"
}